import { render } from "./AppsAndExtensions.vue?vue&type=template&id=2c41c833&scoped=true"
const script = {}

import "./AppsAndExtensions.vue?vue&type=style&index=0&id=2c41c833&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c41c833"]])

export default __exports__